module.exports = __webpack_public_path__ + "media/images/companyPage/courageous-b470d1cb1560952ea952907a9d73ed2e.svg";